import type { GetCustomDatasourcesResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetCustomDatasourcesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomDatasourcesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetCustomDatasources = createQueryHook<
  Record<string, never>,
  GetCustomDatasourcesResponseRow[],
  GetCustomDatasourcesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.customDatasource.customDatasources.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    // The DB column CreatedByUser is nullable but the legacy GraphQL contract
    // exposes it as non-null (a null row would have errored on the Hasura
    // path too) — coalesce to keep the generated shape without widening it.
    custom_datasource: data.map((row) => ({
      ...row,
      CreatedByUser: row.CreatedByUser ?? '',
    })),
  }),
  graphqlDocument: GetCustomDatasourcesDocument,
});
